import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const getDeleteDraftConfirmationModalTitle = (documentType: InvoiceDocumentType, t: TFunction) => {
  switch (documentType) {
    case InvoiceDocumentType.Quote:
      return t('external_invoices.editor.confirm_delete_draft_modal.title_quote')
    case InvoiceDocumentType.Invoice:
    default:
      return t('external_invoices.editor.confirm_delete_draft_modal.title')
  }
}
